export default "__VITE_ASSET__C0ncU7Gw__"